var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c("ItemPriceType", {
            model: {
              value: _vm.form.type,
              callback: function ($$v) {
                _vm.$set(_vm.form, "type", $$v)
              },
              expression: "form.type",
            },
          }),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingOrderMoney.dialog.amountRange"),
                required: "",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "amountStart" } },
                        [
                          _c("BjInputMoney", {
                            model: {
                              value: _vm.form.amountStart,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "amountStart", $$v)
                              },
                              expression: "form.amountStart",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "text-center", attrs: { span: 2 } },
                    [_vm._v(" - ")]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "amountEnd" } },
                        [
                          _c("BjInputMoney", {
                            model: {
                              value: _vm.form.amountEnd,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "amountEnd", $$v)
                              },
                              expression: "form.amountEnd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingOrderMoney.dialog.logistics"),
                prop: "logisticCompanyId",
              },
            },
            [
              _c("BjSelectLogisticCompany", {
                attrs: {
                  value: _vm.form.logisticCompanyId,
                  "default-options": {
                    label: _vm.form.logisticCompanyName,
                    value: _vm.form.logisticCompanyId,
                  },
                },
                on: { change: _vm.onLogistic },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.span } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingOrderMoney.dialog.business"),
                prop: "logisticBusinessId",
              },
            },
            [
              _c("BjSelectLogisticBusiness", {
                attrs: {
                  value: _vm.form.logisticBusinessId,
                  disabled: !_vm.form.logisticCompanyId,
                  "default-params": _vm.defaultParams,
                  "default-options": {
                    label: _vm.form.logisticBusinessName,
                    value: _vm.form.logisticBusinessId,
                  },
                  placeholder: _vm.form.logisticCompanyId
                    ? _vm.$t("chooseText")
                    : _vm.$t("settingOrderMoney.dialog.selectLogisticsValid"),
                },
                on: { change: _vm.onBusiness },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("settingOrderMoney.dialog.priority"),
                prop: "orderNum",
              },
            },
            [
              _c("el-input-number", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  min: 0,
                  max: _vm.MAX_LENGTH.PRIORITY,
                  precision: 0,
                  controls: false,
                },
                model: {
                  value: _vm.form.orderNum,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "orderNum", $$v)
                  },
                  expression: "form.orderNum",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }